// extracted by mini-css-extract-plugin
export default {"google-pay-button":"style_google-pay-button__4zsZM","google-pay-proxy":"style_google-pay-proxy__2O3WC"};